import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import Text from "../horo/Text";
import axios from "axios";
import UserContext from "../Authcontext";

import { API_BASE_URL } from "../api_config";

import "./horo.css";

function HoroscopeBoxes() {
  // const { token } = useContext(UserContext);
  const { user, token } = useContext(UserContext);
  const [dob, setDOB] = useState("");
  const [place, setPlace] = useState("");
  const [meetingTime, setMeetingTime] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [error, setError] = useState("")
  const [period, setPeriod] = useState("AM");

  const navigate = useNavigate();

  const options = [
    { value: "ல", label: "ல" },
    { value: "ரா", label: "ரா" },
    { value: "கே", label: "கே" },
    { value: "சூ", label: "சூ" },
    { value: "சனி", label: "சனி" },
    { value: "செ", label: "செ" },
    { value: "சுக்", label: "சுக்" },
    { value: "புதன்", label: "புதன்" },
    { value: "குரு", label: "குரு" },
    { value: "சந்திரன்", label: "சந்திரன்" },
    { value: "(மா )", label: "(மா )" },
    { value: "(வ )", label: "(வ )" },
  ];

   // Helper function for consistent select component styling and behavior
   const HoroscopeSelect = ({ name, value, onChange }) => (
    <Select
      name={name}
      options={options}
      isMulti
      placeholder="Select..."
      value={value}
      onChange={onChange}
      className="horoscope-select"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({ ...base, minHeight: '32px' }),
        valueContainer: (base) => ({ ...base, padding: '0 8px' }),
        multiValue: (base) => ({ 
          ...base, 
          backgroundColor: 'rgba(255, 102, 0, 0.1)',
          margin: '2px'
        })
      }}
    />
  );

  useEffect(() => {
    const fetchHoroscopeData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/horoscope`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        console.log("user_id " , UserContext)
        console.log("response" , response )
        const horoscopeData = response.data[0];

        const selectedOptionsObj = {};
        for (let i = 1; i <= 24; i++) {
          const boxName = `box${i}`;
          const selectedOption = horoscopeData[boxName];
          if (selectedOption && selectedOption.length > 0) {
            selectedOptionsObj[i] = selectedOption.split(",").map((option) => ({
              value: option,
              label: option,
            }));
          }
        }
        function formatDOB(dob) {
          const dobDate = new Date(dob);
          const year = dobDate.getFullYear();
          const month = String(dobDate.getMonth() + 1).padStart(2, "0");
          const day = String(dobDate.getDate()).padStart(2, "0");
          const formattedDOB = `${year}-${month}-${day}`;
          return formattedDOB;
        }
        setSelectedOptions(selectedOptionsObj);
        setDOB(formatDOB(horoscopeData.date));
        setPlace(horoscopeData.place);
        setMeetingTime(horoscopeData.time);
        setPeriod(horoscopeData.period);
      } catch (error) {
        setError("An error occurred. geting details")
      }
    };

    fetchHoroscopeData();
  }, [token]);

  const handleDOBChange = (value) => {
    setDOB(value);
  };

  const handleTimeChange = (value) => {
    setMeetingTime(value);
  };

  const handlePlaceChange = (value) => {
    setPlace(value);
  };

  const handlePeriodChange = (value) => {
    setPeriod(value);
  };

  const handleChange = (selected, name) => {
    setSelectedOptions((prevSelectedOptionsMap) => ({
      ...prevSelectedOptionsMap,
      [name]: selected,
    }));
  };

  const getSelectedOptions = (name) => {
    return selectedOptions[name] || null;
  };
  
  const handleSaveProfile = async () => {
    const selectedOptionsObj = {};

    for (let i = 1; i <= 24; i++) {
      const boxName = `${i}`;
      const selectedOption = selectedOptions[boxName];

      if (selectedOption && selectedOption.length > 0) {
        selectedOptionsObj[boxName] = selectedOption.map(
          (option) => option.value
        );
      }
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/insertHoroscope`,
        { user,selectedOptionsObj, dob, place, meetingTime, period },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        setError(""); // Clear any previous errors
        alert("Horoscope data saved successfully!");
        // Optionally navigate to a different page if needed
        // navigate("/user-profile"); // Example: navigate to user profile instead
      }
    } catch (error) {
      setError("An error occurred while saving horoscope data");
    }
  };

  return (
    <div className="back">
      <Text
        dob={dob}
        place={place}
        meetingTime={meetingTime}
        period={period}
        handleDOBChange={handleDOBChange}
        handleTimeChange={handleTimeChange}
        handlePlaceChange={handlePlaceChange}
        handlePeriodChange={handlePeriodChange}
      />


       {/* Horoscope Grid Section */}
       <div className="form-section-title">Horoscope Charts</div>
            <div className="horoscope-grid-container">
              <div className="horoscope-charts-wrapper">
                {/* First Horoscope Rashi Chart (4x4 grid) */}
                <div style={{ width: "400px" }} className="horoscope-chart">
                  <h4 className="horoscope-chart-title">Rasi Chart</h4>
                  <div className="horoscope-grid">
                    {/* { Row - 1 } */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="1" value={getSelectedOptions("1")} onChange={(selected) => handleChange(selected, "1")} />
                        
                    </div>
                   
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="2" value={getSelectedOptions("2")} onChange={(selected) => handleChange(selected, "2")} />
                        
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="3" value={getSelectedOptions("3")} onChange={(selected) => handleChange(selected, "3")} />
                        
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="4" value={getSelectedOptions("4")} onChange={(selected) => handleChange(selected, "4")} />
                        
                    </div>

                    {/* { Row - 2 } */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="5" value={getSelectedOptions("5")} onChange={(selected) => handleChange(selected, "5")} />
                        
                    </div>
                    <div className="horoscope-cell horoscope-center" style={{ gridColumn: "2 / span 2", gridRow: "2 / span 2" }}>
                      <div className="horoscope-center-text">
                        <h3>ராசி</h3>
                      </div>
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="6" value={getSelectedOptions("6")} onChange={(selected) => handleChange(selected, "6")} />
                        
                    </div>
                    
                    {/* Row - 3 */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="7" value={getSelectedOptions("7")} onChange={(selected) => handleChange(selected, "7")} />
                        
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="8" value={getSelectedOptions("8")} onChange={(selected) => handleChange(selected, "8")} />
                        
                    </div>

                    {/* Row - 4 */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="9" value={getSelectedOptions("9")} onChange={(selected) => handleChange(selected, "9")} />
                        
                    </div>
                    
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="10" value={getSelectedOptions("10")} onChange={(selected) => handleChange(selected, "10")} />
                        
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="11" value={getSelectedOptions("11")} onChange={(selected) => handleChange(selected, "11")} />
                        
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="12" value={getSelectedOptions("12")} onChange={(selected) => handleChange(selected, "12")} />
                      
                    </div>
                  </div>
                </div>

                {/* Second Horoscope Navamsa Chart (4x4 grid) */}
                <div style={{ width: "400px" }} className="horoscope-chart">
                  <h4 className="horoscope-chart-title">Navamsa Chart</h4>
                  <div className="horoscope-grid">
                    {/* Row - 1 */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="13" value={getSelectedOptions("13")} onChange={(selected) => handleChange(selected, "13")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="14" value={getSelectedOptions("14")} onChange={(selected) => handleChange(selected, "14")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="15" value={getSelectedOptions("15")} onChange={(selected) => handleChange(selected, "15")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="16" value={getSelectedOptions("16")} onChange={(selected) => handleChange(selected, "16")} />
                    </div>

                    {/* Row - 2 */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="17" value={getSelectedOptions("17")} onChange={(selected) => handleChange(selected, "17")} />
                    </div>

                    <div className="horoscope-cell horoscope-center" style={{ gridColumn: "2 / span 2", gridRow: "2 / span 2" }}>
                      <div className="horoscope-center-text">
                        <h3>நவம்சம்</h3>
                      </div>
                    </div>

                    <div className="horoscope-cell">
                      <HoroscopeSelect name="18" value={getSelectedOptions("18")} onChange={(selected) => handleChange(selected, "18")} />
                    </div>
                    
                    {/* Row - 3 */}
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="19" value={getSelectedOptions("19")} onChange={(selected) => handleChange(selected, "19")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="20" value={getSelectedOptions("20")} onChange={(selected) => handleChange(selected, "20")} />
                    </div>

                    
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="21" value={getSelectedOptions("21")} onChange={(selected) => handleChange(selected, "21")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="22" value={getSelectedOptions("22")} onChange={(selected) => handleChange(selected, "22")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="23" value={getSelectedOptions("23")} onChange={(selected) => handleChange(selected, "23")} />
                    </div>
                    <div className="horoscope-cell">
                      <HoroscopeSelect name="24" value={getSelectedOptions("24")} onChange={(selected) => handleChange(selected, "24")} />
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="form-group">
                <div className="info-badge">
                  <span className="info-icon">ℹ️</span>
                  <span className="info-text">Select the appropriate symbols in each box according to your horoscope. You can select multiple symbols per box.</span>
                </div>
              </div>
            </div>

            <div className="photo-guidelines">
              <h4 className="guidelines-title">Why is horoscope information important?</h4>
              <ul className="guidelines-list">
                <li>Helps in matching astrological compatibility</li>
                <li>Important for traditional families who consider horoscope matching</li>
                <li>Provides additional information for potential matches</li>
                <li>Can be a deciding factor for many families in the matrimony process</li>
              </ul>
            </div>

      <div className="ga">
        <button
        style={{backgroundColor: "#e84393"}}
          className="btn btn-primary mb-4"
          
          type="submit"
          onClick={handleSaveProfile}
        >
          Save Profile
          <i className="uil uil-navigator"></i>
        </button>
        {error && <p>{error}</p>}
      </div>
    </div>
  );
}

export default HoroscopeBoxes;
